import type { SchemaOf } from '../helpers';
import { objectSchemaOf, Joi } from '../helpers';
import type { Strategy } from './configureParams';
import { strategySchema } from './configureParams';

export interface IWordData {
  startTime: number;
  endTime: number;
  word: string;
  confidence: number;
}

const wordDataSchema = objectSchemaOf<IWordData>({
  startTime: Joi.number().required(),
  endTime: Joi.number().required(),
  word: Joi.string().required(),
  confidence: Joi.number().required(),
});

export const recognitionResultSchemaMap: SchemaOf<IRecognitionResult> = {
  text: Joi.string().required(),
  confidence: Joi.number().required(),
  isFinal: Joi.boolean().required(),
  words: Joi.array().items(wordDataSchema),
  engine: Joi.string().required(),
  timestamp: Joi.number().optional(),
  strategy: strategySchema.optional(),
};

export const recognitionResultSchema = objectSchemaOf<IRecognitionResult>(
  recognitionResultSchemaMap
);

export interface IRecognitionResult {
  text: string;
  confidence: number;
  isFinal: boolean;
  words?: IWordData[];
  engine: string;
  timestamp?: number;
  strategy?: Strategy;
}
